import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';

import SettingItem from './SettingItem/SettingItem';
import SettingSwitchs from './SettingSwitchs/SettingSwitchs';
import SettingModal from './SettingModal/SettingModal';



import './MobileSetting.css';

export default class MobileSetting extends Component {


  render() {
    const {
      settings,
      switchs,
      social,
      phonenumber,
      email,
      username,
      password,
      password2,
      notif,
      dark,
      openPassword,
      openUsername,
      openEmail,
      openNumber,
      validEmail,
      validPassword,
      validUsername,
      validPhonenumber,
      openModal,
      closeModal,
      changeValue,
      setNotif,
      setDark,
    } = this.props;
    return (
      <Fragment>
        <div className={openNumber || openEmail || openUsername || openPassword ? "phone-number-blur  mobile-setting d-flex flex-column" : "mobile-setting d-flex flex-column"}>
          <div className="mobile-setting__header d-flex">
            <h1>تنظیمات حساب کاربری</h1>
            <div className="mobile-setting__header--icons d-flex">
              <Link to="/">بازگشت</Link>
            </div>
          </div>
          <div className="mobile-setting__fields">
            {
              settings.map(item => (
                <SettingItem settings={item} openModal={openModal} key={item.name} />
              ))
            }
          </div>

          <div className="mobile-setting__switchs d-flex flex-column">
            {
              switchs.map(item => (
                <SettingSwitchs switchs={item} key={item.name} setNotif={setNotif} setDark={setDark} name={item.name} />
              ))
            }
          </div>
          <div className="mobile-setting__links">
            <Link to="/privacy"><div>قوانین و مقررات</div></Link>
            <button>خروج از حساب کاربری</button>
          </div>
          <div className="mobile-setting__social d-flex">
            {
              social.map(item => (
                <a href={item.links} key={item.name}>
                  <img src={item.icon} />
                </a>
              ))
            }
          </div>
        </div>
        { openNumber ? <SettingModal value={phonenumber} valid={validPhonenumber} field={settings[0]} closeModal={closeModal} changeValue={changeValue} /> : null}
        { openEmail ? <SettingModal valid={validEmail} value={email} field={settings[1]} closeModal={closeModal} changeValue={changeValue} /> : null}
        { openUsername ? <SettingModal value={username} valid={validUsername} field={settings[2]} closeModal={closeModal} changeValue={changeValue} /> : null}
        { openPassword ? <SettingModal value={password} value2={password2} valid={validPassword} field={settings[3]} closeModal={closeModal} changeValue={changeValue} /> : null}
      </Fragment >
    );
  }
}